import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { hashHistory } from 'react-router';

import { Typography } from '../../components/atoms';
import { ClosedShoppingCartXL as ClosedShoppingCartXLIcon } from '../../components/icons';
import { Page } from '../../components/layouts';
import { StateProps } from '../../weborder/component/Unavailable';

const useStyles = makeStyles(() => ({
  unavailable: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '25vh 24px',

    '& .fd-text': {
      textAlign: 'center',
    },
  },
  icon: {
    marginBottom: '3vh',
  },
}));

type Props = StateProps;

export function Unavailable(props: Props): JSX.Element {
  const classes = useStyles();
  const { appConfig, translate } = props;

  useEffect(() => {
    if (
      appConfig.status === 'success' &&
      (appConfig.data.DeliveryEnabled || appConfig.data.PickupEnabled)
    ) {
      hashHistory.replace('/where');
    }
  }, [appConfig.status]);

  return (
    <Page pageName="unavailable" noLayout>
      <div className={classes.unavailable}>
        <div className={classes.icon}>
          <ClosedShoppingCartXLIcon />
        </div>

        <Typography variant="h1">
          {translate('Online_ordering_currently_unavailable')}
        </Typography>

        <Typography>{translate('Check_back_soon')}</Typography>
      </div>
    </Page>
  );
}
